(function () {
  if (window.__dcroStickyAtcDraft) return;
  window.__dcroStickyAtcDraft = true;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var primaryButton = document.querySelector('.product__info-container button[name="add"]:not(.dcro-sticky-atc__button), product-form button[name="add"]:not(.dcro-sticky-atc__button), form[action*="/cart/add"] button[name="add"]:not(.dcro-sticky-atc__button)');
    if (!primaryButton || document.querySelector('.dcro-sticky-atc')) return;

    var productInfo = primaryButton.closest('.product__info-container') || document;
    var variantSelects = productInfo.querySelector('variant-selects') || document.querySelector('variant-selects');
    var titleSource = document.querySelector('.product__title h1, h1');
    var priceSource = productInfo.querySelector('.price, [class*="price"]') || document.querySelector('.price, [class*="price"]');

    var bar = document.createElement('div');
    bar.className = 'dcro-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = [
      '<button class="dcro-sticky-atc__close" type="button" aria-label="' + ({sv:'Stäng',da:'Luk',en:'Close'}[(document.documentElement.lang||'').slice(0,2)]||'Lukk') + '">&times;</button>',
      '<div class="dcro-sticky-atc__meta">',
      '  <div class="dcro-sticky-atc__title"></div>',
      '  <div class="dcro-sticky-atc__price"></div>',
      '</div>',
      '<div class="dcro-sticky-atc__variant-wrap"></div>',
      '<button class="dcro-sticky-atc__button" type="button"></button>'
    ].join('');
    document.body.appendChild(bar);

    var titleNode = bar.querySelector('.dcro-sticky-atc__title');
    var priceNode = bar.querySelector('.dcro-sticky-atc__price');
    var variantWrap = bar.querySelector('.dcro-sticky-atc__variant-wrap');
    var stickyButton = bar.querySelector('.dcro-sticky-atc__button');
    var closeButton = bar.querySelector('.dcro-sticky-atc__close');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var scheduled = false;
    var dismissed = false;
    var variantSignature = '';

    function clean(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function textWithoutLiveValue(element) {
      if (!element) return '';
      var clone = element.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('[data-selected-value], svg, .svg-wrapper'), function (node) {
        node.remove();
      });
      return clean(clone.textContent).replace(/:$/, '');
    }

    function primaryButtonText() {
      var label = clean(primaryButton.innerText || primaryButton.textContent);
      return label || primaryButton.getAttribute('aria-label') || 'Legg i handlekurv';
    }

    function currentPriceText() {
      var source = productInfo.querySelector('.price__sale .price-item--sale, .price-item--sale, .price__regular .price-item--regular, .price-item--regular') || priceSource;
      if (!source) return '';
      var text = clean(source.innerText || source.textContent);
      text = text.replace(/Vanlig pris|Salgspris|Försäljningspris|Normaali hinta|Alennushinta|Regular price|Sale price/gi, ' ');
      text = clean(text);
      var matches = text.match(/(?:kr\s*)?\d[\d\s.]*,\d{2}\s*kr|(?:kr\s*)?\d[\d\s.]*,-|€\s?\d[\d\s.,]*|\d[\d\s.]*,\d{2}\s*kr|\d[\d\s.]*\s*kr/gi);
      if (matches && matches.length) return clean(matches[matches.length - 1]).slice(0, 34);
      return text.slice(0, 34);
    }

    function closeLabel() {
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('sv') === 0) return 'Stäng';
      if (lang.indexOf('fi') === 0) return 'Sulje';
      if (lang.indexOf('da') === 0) return 'Luk';
      if (lang.indexOf('en') === 0) return 'Close';
      return 'Lukk';
    }

    function fallbackOptionLabel() {
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('sv') === 0) return 'Val';
      if (lang.indexOf('fi') === 0) return 'Valinta';
      if (lang.indexOf('da') === 0) return 'Valg';
      return 'Valg';
    }

    function optionTextForInput(group, input) {
      var label = input.id ? group.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]') : null;
      if (label) {
        var clone = label.cloneNode(true);
        Array.prototype.forEach.call(clone.querySelectorAll('.visually-hidden, .hidden, svg, .svg-wrapper'), function (node) {
          node.remove();
        });
        var text = clean(clone.textContent);
        if (text) return text;
      }
      return clean(input.getAttribute('aria-label') || input.value);
    }

    function getVariantGroups() {
      if (!variantSelects) return [];

      var groups = [];
      Array.prototype.forEach.call(variantSelects.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'), function (group, index) {
        var radios = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
        var select = group.querySelector('select');
        var label = textWithoutLiveValue(group.querySelector('legend, label.form__label')) || fallbackOptionLabel();

        if (radios.length > 1) {
          groups.push({
            index: index,
            type: 'radio',
            source: group,
            label: label,
            options: radios.map(function (input) {
              return {
                value: input.value,
                label: optionTextForInput(group, input),
                selected: input.checked,
                disabled: input.disabled || input.getAttribute('aria-disabled') === 'true'
              };
            })
          });
          return;
        }

        if (select && select.options && select.options.length > 1) {
          groups.push({
            index: index,
            type: 'select',
            source: select,
            label: label,
            options: Array.prototype.map.call(select.options, function (option) {
              return {
                value: option.value,
                label: clean(option.textContent || option.value),
                selected: option.selected,
                disabled: option.disabled
              };
            })
          });
        }
      });

      return groups;
    }

    function signatureFor(groups) {
      return groups.map(function (group) {
        return group.label + ':' + group.options.map(function (option) {
          return option.value + '/' + option.label + '/' + (option.disabled ? '1' : '0');
        }).join('|');
      }).join('||');
    }

    function selectMainOption(optionIndex, value) {
      var group = getVariantGroups().filter(function (item) {
        return item.index === optionIndex;
      })[0];
      if (!group) return;

      if (group.type === 'radio') {
        var input = Array.prototype.filter.call(group.source.querySelectorAll('input[type="radio"]'), function (candidate) {
          return candidate.value === value;
        })[0];
        if (input && !input.disabled && !input.checked) {
          input.click();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (group.type === 'select' && group.source.value !== value) {
        group.source.value = value;
        group.source.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function rebuildVariantUi(groups) {
      variantWrap.innerHTML = '';
      variantSignature = signatureFor(groups);
      bar.classList.toggle('has-variant-options', groups.length > 0);
      document.body.classList.toggle('dcro-sticky-atc-has-variants', groups.length > 0);

      groups.forEach(function (group) {
        var field = document.createElement('label');
        field.className = 'dcro-sticky-atc__variant-field';

        var label = document.createElement('span');
        label.className = 'dcro-sticky-atc__variant-label';
        label.textContent = group.label;

        var select = document.createElement('select');
        select.className = 'dcro-sticky-atc__variant-select';
        select.dataset.optionIndex = String(group.index);
        select.setAttribute('aria-label', group.label);

        group.options.forEach(function (option) {
          var item = document.createElement('option');
          item.value = option.value;
          item.textContent = option.label;
          item.disabled = option.disabled;
          item.selected = option.selected;
          select.appendChild(item);
        });

        select.addEventListener('change', function () {
          selectMainOption(Number(select.dataset.optionIndex), select.value);
          scheduleUpdate();
        });

        field.appendChild(label);
        field.appendChild(select);
        variantWrap.appendChild(field);
      });
    }

    function syncVariantUi() {
      var groups = getVariantGroups();
      var nextSignature = signatureFor(groups);
      if (nextSignature !== variantSignature) {
        rebuildVariantUi(groups);
      }

      Array.prototype.forEach.call(variantWrap.querySelectorAll('.dcro-sticky-atc__variant-select'), function (select) {
        var optionIndex = Number(select.dataset.optionIndex);
        var group = groups.filter(function (item) {
          return item.index === optionIndex;
        })[0];
        if (!group) return;
        var selected = group.options.filter(function (option) {
          return option.selected;
        })[0];
        if (selected && select.value !== selected.value) {
          select.value = selected.value;
        }
      });
    }

    function syncContent() {
      titleNode.textContent = clean(titleSource && (titleSource.innerText || titleSource.textContent)).slice(0, 90);
      priceNode.textContent = currentPriceText();
      stickyButton.textContent = primaryButtonText();
      stickyButton.disabled = Boolean(primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true');
      closeButton.setAttribute('aria-label', closeLabel());
      syncVariantUi();
    }

    function shouldShow() {
      if (dismissed) return false;
      if (!mobileQuery.matches) return false;
      if (!document.body || document.body.classList.contains('overflow-hidden')) return false;
      var rect = primaryButton.getBoundingClientRect();
      return rect.bottom < 0 && document.documentElement.scrollHeight > window.innerHeight + 240;
    }

    function updatePreviewOffset() {
      var wrapper = document.getElementById('PBarNextFrameWrapper');
      var offset = 0;
      if (wrapper) {
        var rect = wrapper.getBoundingClientRect();
        if (rect.height && rect.bottom > window.innerHeight - 4) {
          offset = Math.ceil(rect.height);
        }
      }
      document.documentElement.style.setProperty('--dcro-sticky-preview-offset', offset + 'px');
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('dcro-sticky-atc-visible', visible);
    }

    function update() {
      scheduled = false;
      syncContent();
      updatePreviewOffset();
      setVisible(shouldShow());
    }

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    stickyButton.addEventListener('click', function () {
      syncContent();
      if (stickyButton.disabled) {
        primaryButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      primaryButton.click();
    });

    closeButton.addEventListener('click', function () {
      dismissed = true;
      setVisible(false);
    });

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', scheduleUpdate);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(scheduleUpdate);
    }

    if ('MutationObserver' in window) {
      new MutationObserver(scheduleUpdate).observe(productInfo, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    syncContent();
    scheduleUpdate();
  });
})();

/* tk-sv-product-media-fallback-start */
;(() => {
  if (window.__tkSvProductAssetMediaFallback) return;
  window.__tkSvProductAssetMediaFallback = true;

  var isSv =
    window.location.pathname.indexOf('/sv-se') === 0 ||
    (document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0 ||
    ((window.Shopify && Shopify.locale) || '').toLowerCase().indexOf('sv') === 0;
  if (!isSv) return;

  var imageReplacements = {
        '/Detaljer_3_bff8fe2c-62eb-4d13-a3a1-3b1d202274d7.jpg': 'https://cdn.shopify.com/s/files/1/0872/3926/2543/files/tk-sv-steinmatte-detaljer-chatgpt-20260708.jpg?v=1783507170',
        '/grillkurv_03.jpg': 'https://cdn.shopify.com/s/files/1/0872/3926/2543/files/tk-sv-grillkurv-03-rullar-jamnt-chatgpt-20260708.jpg?v=1783507171',
        '/grillkurv_04.jpg': 'https://cdn.shopify.com/s/files/1/0872/3926/2543/files/tk-sv-grillkurv-04-rostfritt-stal-chatgpt-20260708.jpg?v=1783507171',
        '/grillkurv_05.jpg': 'https://cdn.shopify.com/s/files/1/0872/3926/2543/files/tk-sv-grillkurv-05-storlekar-varianter-chatgpt-20260708.jpg?v=1783507170',
        '/grillkurv_06.jpg': 'https://cdn.shopify.com/s/files/1/0872/3926/2543/files/tk-sv-grillkurv-06-dette-far-du-chatgpt-20260708.jpg?v=1783507170'
  };

  function replacementForImage(value) {
    if (!value) return null;
    var keys = Object.keys(imageReplacements);
    for (var i = 0; i < keys.length; i += 1) {
      if (value.indexOf(keys[i]) !== -1) return imageReplacements[keys[i]];
    }
    return null;
  }

  function patchImages(root) {
    var target = root && root.querySelectorAll ? root : document;
    target.querySelectorAll('img, source, a').forEach(function (element) {
      ['src', 'srcset', 'data-src', 'data-srcset', 'href'].forEach(function (attr) {
        var value = element.getAttribute && element.getAttribute(attr);
        var replacement = replacementForImage(value);
        if (replacement) element.setAttribute(attr, replacement);
      });
      if (element.tagName === 'IMG') {
        var current = element.currentSrc || element.src || element.getAttribute('src');
        var replacement = replacementForImage(current);
        if (replacement) {
          element.removeAttribute('srcset');
          element.removeAttribute('data-srcset');
          element.src = replacement;
        }
      }
    });
  }

  function schedule(root) {
    window.requestAnimationFrame(function () { patchImages(root || document); });
  }

  patchImages(document);
  document.addEventListener('DOMContentLoaded', function () { patchImages(document); });
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') schedule(mutation.target);
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) schedule(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset', 'href']
  });
  [250, 750, 1500, 3000, 6000].forEach(function (delay) {
    window.setTimeout(function () { patchImages(document); }, delay);
  });
})();
/* tk-sv-product-media-fallback-end */
